<main class="container-fluid page-container p-0">
  <router-outlet></router-outlet>
</main>